'use client';
import React from 'react';
import {
  Button as MaterialButton,
  ButtonProps as MaterialButtonProps,
  Link as MaterialLink,
  LinkProps as MaterialLinkProps,
} from '@mui/material';
import { RouterLink } from '@peerless/ui-locale';

export type LinkProps = Omit<MaterialLinkProps<typeof RouterLink>, 'ref'>;

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <MaterialLink ref={ref} component={RouterLink} {...props} />
));

export type ButtonProps = MaterialButtonProps<typeof RouterLink>;

export const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonProps>((props, ref) => (
  <MaterialButton ref={ref} component={RouterLink} {...props} />
));
